// extracted by mini-css-extract-plugin
export default {"root":"R97hF","price":"xvkWO","currencyLeft":"EJtdf","amount":"EYbyT","isLocalCyrillic":"DjDNO","currencyRight":"ti985","aMonth":"yg89u","discountPrice":"U-yXC","priceFree":"SUvMU"};